import React from 'react';

const SubscriptionAlertPopup = ({ title, message, onClose }) => {
  // Prevent the event from bubbling up to the overlay
  const stopPropagation = (e) => e.stopPropagation();

  return (
    <div className="subsc-popup-overlay" onClick={onClose}>
      <div className="subsc-popup-box" onClick={stopPropagation}>
        
        {/* Cross Close Button */}
        <button 
          className="subsc-popup-cross-btn" 
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>

        <h2 className="subsc-popup-title">{title}</h2>
        <div className="subsc-popup-body">{message}</div>

        <div className="subsc-popup-footer">
          <button className="subsc-popup-close-btn" onClick={onClose}>
            Upgrade Plan
          </button>
          <button className="subsc-popup-close-btn" onClick={onClose}>
            OK
          </button>
        </div>

      </div>
    </div>
  );
};

export default SubscriptionAlertPopup;
